module.exports = "/_next/static/images/021b00672a5b72d67261128bf02653cf-product-information-md-1x.jpg.webp";